import React, { useEffect, useRef, useState } from "react";
import styles from "./comp_css/chapter_12.module.css";
import Head from "next/head";
import { useRouter } from "next/router";
import { Link } from "@mui/material";
import MembershipModal from "../../../components/Modal/MembershipModal";
import BlockData from "../../../central-doctraine-json/chapter12.json";
import Common_html from "./Common_html";


export default function Chapter_12() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };

  return (
    <>
      <Head>
        <title>THE MANDALA ARCHETYPE | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XII"
        ></meta>
        <meta
          property="og:title"
          content="THE MANDALA ARCHETYPE | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter12_OG_image_Mithun_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Image showcasing a detailed and vibrant mandala at the center, symbolizing the Mandala Archetype within the Divine Infinite Being framework. The mandala features intricate patterns and symmetrical designs that radiate from a central point, surrounded by cosmic elements and spiritual symbols. The image reflects the concept of unity, wholeness, and the interconnectedness of the divine and the individual self."></meta>
        <meta
          property="og:description"
          content="The Mandala archetype went from symbolic as Jung discovered through his psychology practice into a fully realized phenomena that permeated both the psychic and physical worlds."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=12"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter12_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Image showcasing a detailed and vibrant mandala at the center, symbolizing the Mandala Archetype within the Divine Infinite Being framework. The mandala features intricate patterns and symmetrical designs that radiate from a central point, surrounded by cosmic elements and spiritual symbols. The image reflects the concept of unity, wholeness, and the interconnectedness of the divine and the individual self."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=12"></meta>
        <meta name="twitter:title" content="THE MANDALA ARCHETYPE | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="The Mandala archetype went from symbolic as Jung discovered through his psychology practice into a fully realized phenomena that permeated both the psychic and physical worlds."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=12" />
      </Head>


       <Common_html BlockData={BlockData} />
      <MembershipModal membershipOpen={membershipOpen} setMembershipOpen={setMembershipOpen}/>
    </>
  );
}
